// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"360fb8a2","259":"9784dbac","304":"6e2550f0","354":"b7aa041d","367":"8a971223","433":"6b4f7148","466":"48ec4a1b","588":"8e072a14","739":"b3bac575","759":"ca3a721c","879":"e69fbf37","897":"38d61f64","961":"da55e400"}[chunkId] + ".js";
};